<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Característica da Renda Fixa
                </span>
                <button mat-mini-fab 
                    color="accent"
                    matTooltip="Adicionar Novo Produto"
                    (click)="openCadastro()"
                    style="margin-left: 16px;">
                    <mat-icon>add_circle</mat-icon>
                </button>
            <!-- / ADD BUTTON -->
            </div>
            <!-- / APP TITLE -->           

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <mat-tab-group>
                <mat-tab
                    class="accent title"
                    label="Ativos"
                >
                    <ng-template matTabContent>
                        <app-lista-produto [parameter]="{inative: false}"></app-lista-produto>
                    </ng-template>
                </mat-tab>

                <mat-tab
                    class="accent title"
                    label="Inativos"
                >
                    <ng-template matTabContent>  
                        <app-lista-produto [parameter]="{inative: true}"></app-lista-produto>                   
                    </ng-template>
                </mat-tab>              

            </mat-tab-group>
            
        </div>
    </div>
</div>